<div class="product">
  <div class="product__general">
    <div class="product__general-info product-info">
      <div class="product-info__content">
        <span class="product-info__content-amount">{{ count() }}x </span>
        <span class="product-info__content-name">
          {{ name() }}
        </span>
        @if (variantName()) {
          <span class="product-info__content-variant">{{ variantName() }}</span>
        }
      </div>
    </div>

    <span class="product__general-price">
      {{ price() | formattedCurrency: 0 }}
    </span>
  </div>

  @if (addOns().length > 0) {
    <div class="product__add-ons add-ons">
      <ul class="add-ons__list">
        @for (addOn of groupedAddOns() | keyvalue; track $index) {
          <li class="add-ons__list-item add-on">
            <h6 class="add-on__title" [innerHtml]="addOn.key"></h6>

            <ul class="add-on__options">
              @for (addOnValue of addOn.value; track $index) {
                <li class="add-on__options-item option">
                  <span class="option__name" [innerHtml]="addOnValue.value"></span>

                  @if (addOnValue.price != 0) {
                    <span class="option__price">
                      +{{ addOnValue.price | formattedCurrency: 0 }}
                    </span>
                  }
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  }
</div>
